import React from 'react';
import { BrowserRouter as Router,Routes ,Route} from 'react-router-dom';
import Home from './../App';
import Product from './../pages/product/product';
import Services from '../pages/services/services';

const AppRouter = () =>(  
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/product" element={<Product/>} />
      <Route path="/services" element={<Services/>} />
       {/* <Route path="/login" element={<Login />} /> */}
      {/*<Route path="/aaplesarkar" element={<Aaplesarkar/>}/>
      <Route path="/grievance" element={<Grievance/>}/>
      <Route path="/nationality" element={<Nationality/>}/>
      <Route path="/residence" element={<Residence/>}/>
      <Route path="/landing" element={<Landing/>}/> */}
    </Routes>
  </Router>
);
export default AppRouter;